import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { DATALAKE_EMISSAO_LTV_PATH } from 'src/utils/api-routes'
import ParameterDatalakeEmissaoLTVTable from 'src/pages/parameters/parameters-datalake/tables/parameter-datalake-emissao-ltv'

const TableEmissaoLTV = ({ loading, cetipIsin }) => {
    const cetip = useMemo(() => {
        if (!cetipIsin) return ''

        // Se for objeto com campo CETIP
        if (typeof cetipIsin === 'object' && cetipIsin.CETIP) {
            return cetipIsin.CETIP.toString().trim()
        }

        // Se já for string simples
        if (typeof cetipIsin === 'string') {
            return cetipIsin.trim()
        }

        return ''
    }, [cetipIsin])

    const filters = useMemo(
        () => (cetip ? [{ field: 'CETIP__exact', value: cetip }] : []),
        [cetip]
    )

    const tableKey = useMemo(() => `ltv-${cetip || 'all'}`, [cetip])

    return (
        <ParameterDatalakeEmissaoLTVTable
            key={tableKey}
            customFilter={false}
            disableToolbar
            filters={filters}
            endpoint={`${DATALAKE_EMISSAO_LTV_PATH}?`}
            loading={loading}
        />
    )
}

TableEmissaoLTV.propTypes = {
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    cetipIsin: PropTypes.oneOfType([
        PropTypes.string, 
        PropTypes.shape({
            CETIP: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ]),
}

export default TableEmissaoLTV